import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import type {FourGridSliceCards} from 'prismicio-types'

type CardImage = FourGridSliceCards['primary']['cards'][number]['image']
type CardIcon = FourGridSliceCards['primary']['cards'][number]['icon']

type CardProps = {
  title: string
  subtitle: string
  icon: CardIcon
  image?: CardImage
  className?: string
  iconOverlay?: boolean
}

export const Card = ({title, subtitle, icon, image, className = '', iconOverlay = false}: CardProps) => (
  <div
    className={`flex size-full flex-col gap-3 rounded-lg bg-moss-white p-4 lg:gap-4 ${
      image ? 'lg:p-6' : ''
    } ${className}`}
  >
    {image && isFilled.image(image) && (
      <div className="relative">
        <picture>
          {isFilled.imageThumbnail(image.mobile) && (
            <source
              media="(max-width: 1024px)"
              srcSet={image.mobile.url + '?auto=compress,format&fit=max&w=768'}
              sizes="50vw"
            />
          )}
          <PrismicNextImage
            field={image}
            className="aspect-[141/100] w-full rounded-[6px] object-cover md:aspect-[141/100] lg:aspect-square"
          />
        </picture>
        {iconOverlay && isFilled.image(icon) && (
          <PrismicNextImage
            field={icon}
            className="absolute right-2 top-2 hidden size-6 min-w-6 overflow-hidden lg:block"
          />
        )}
      </div>
    )}

    <div className={`${iconOverlay ? 'lg:hidden' : ''} flex w-full justify-between`}>
      <div className="flex flex-col gap-1.5">
        <p className="text-tg-body-l font-medium text-moss-black">{title}</p>
        <span className="text-button-s text-moss-black/[60%]">{subtitle}</span>
      </div>
      {isFilled.image(icon) && <PrismicNextImage field={icon} className="size-6 min-w-6 self-end overflow-hidden" />}
    </div>
    {iconOverlay && (
      <div className="hidden w-full flex-col gap-1.5 lg:flex">
        <p className="text-tg-body-l font-medium text-moss-black">{title}</p>
        <span className="text-button-s text-moss-black/[60%]">{subtitle}</span>
      </div>
    )}
  </div>
)
